import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseSummaryOfAllAllocatedAndConsumedProps<T> = {
  filters?: {
    search?: string;
    page?: number;
    governmentAllocationIds?: string[]
  };
  mapper?: (data: any) => T,
  enabled?: boolean
};

export const useSummaryOfAllAllocatedAndConsumed = <T,>({
  filters: { search, page, governmentAllocationIds } = {},
  mapper = Mapper.default<T>(),
  enabled = false
}: UseSummaryOfAllAllocatedAndConsumedProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['summaryOfAllAllocatedAndConsumed', search, page, governmentAllocationIds],
    queryFn: () => {
      return privateAxios.get(`/billing/government_allocations/summary_of_all_allocated_and_consumed`, {
        params: {
          search,
          page,
          'government_allocation_ids': governmentAllocationIds
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
    enabled
  });

  return { data, meta, ...rest };
};
